export interface LogoProps {
  isBig: boolean;
}

export const logoSmallWidth = 60;
export const logoBigWidth = 100;

export const logoSmallMargin = 0;
export const logoBigMargin = 0;
